// Candidates attached to a request 2.0 (ITSRT2-1347): /recruiting-tool/api/v1/vacancy-claims/{id}/candidates

// A request keeps one decision per candidate, a new decision overwrites the previous one
export enum RequestCandidateDecisionEnum {
  Suitable = 'SUITABLE',
  NotSuitable = 'NOT_SUITABLE',
}

// Why a candidate was not attached: such candidates come in `rejected` of the 200 answer
export enum RequestCandidateRejectionReasonEnum {
  CandidateNotFound = 'CANDIDATE_NOT_FOUND',
  AlreadyAttached = 'ALREADY_ATTACHED',
  AttachedToOtherClaim = 'ATTACHED_TO_OTHER_CLAIM',
}

// The backend attaches at most 20 distinct candidates at once (the limit is configurable and not in the API)
export const MaxRequestCandidatesAttachCount = 20;

// US-10.2: the pre-screening list shows 50 candidates per page by default
export const RequestCandidatesPageSizes = [
  { title: '10', value: '10' },
  { title: '20', value: '20' },
  { title: '50', value: '50' },
];
export const RequestCandidatesDefaultPageSize = 50;
